// src/theme.js
import { createTheme } from "@mui/material/styles";

// Central theme for the entire app based on requested palette:
// red:   #eebab2
// blue:  #a8bdd2
// yellow:#f6d391
// green: #cdd5c0
// beige: #fff6ef
const theme = createTheme({
  palette: {
    primary: { main: "#c9d2db" },
    secondary: { main: "#f6d391" },
    error: { main: "#eebab2" },
    success: { main: "#cdd5c0" },
    warning: { main: "#f6d391" },
    info: { main: "#a8bdd2" },
    background: {
      default: "#ffffffff", // beige for app background
      paper: "#ffffff"
    },
    custom: {
      red: "#e8cdc5",
      blue: "#c9d2db",
      yellow: "#d1c1b8",
      green: "#cbc7b7",
      beige: "#ede9e3",
    },
  },
  typography: {
    fontFamily: "'Cerebri'",
    htmlFontSize: 16,
    h1: {
      fontFamily: "'Just Another Hand'",
      fontWeight: 700,
      fontSize: "5rem",
      lineHeight: 1.1,
      letterSpacing: "-0.02em",
      textTransform: "uppercase",
    },
    h2: {
      fontFamily: "'Just Another Hand'",
      fontWeight: 600,
      fontSize: "2.125rem",
      textTransform: "uppercase",
    },
    h3: {
      fontFamily: "'Just Another Hand'",
      fontWeight: 500,
      fontSize: "1.5rem",
      textTransform: "uppercase",
    },
    h4: {
      fontFamily: "'Just Another Hand'",
      fontWeight: 500,
      textTransform: "uppercase",
    },
    h5: {
      fontFamily: "'Just Another Hand'",
      fontWeight: 500,
      textTransform: "uppercase",
    },
    h6: {
      fontFamily: "'Just Another Hand'",
      fontWeight: 500,
      textTransform: "uppercase",
    },
    body1: { fontSize: "1rem", lineHeight: 1.6 },
    body2: { fontSize: "0.95rem", lineHeight: 1.6 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiContainer: {
      defaultProps: { maxWidth: "lg" },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "unset",
        },
      },
    },
    MuiList: {
      defaultProps: { dense: false },
      styleOverrides: {
        root: {
          '@media (max-width:600px)': {
            paddingTop: 0,
            paddingBottom: 0,
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: { wordBreak: 'break-word' },
      },
    },
  },
});

export default theme;
